import { render, staticRenderFns } from "./ChinaTUnionIcon.vue?vue&type=template&id=c5c90370&"
import script from "./ChinaTUnionIcon.vue?vue&type=script&lang=js&"
export * from "./ChinaTUnionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports